
$(function () {

    const $from = $('.form-group.from input[name="From"]');

    if ($from.is(':hidden')) {
        $from.val('N/A');
    }
});
